<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                this.$l('form_label_Search_by_operator_Departmentn') ||
                  '根据业务员、部门搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="exportData()"
              v-if="allow('E')"
            >
              <i class="el-icon-folder-opened"></i>
              {{ $l('INDEX.btn_export') || '导出' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="680px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-col :span="8">
              <el-form-item
                :label="this.$l('from_label_Product_line') || '产品线'"
              >
                <dict-select
                  :placeholder="
                    this.$l('table_label_pe_select_productLine') ||
                      '请选择产品线'
                  "
                  size="small"
                  clearable
                  filterable
                  v-model="form.productLine"
                  :body="productLineParams"
                  url="/sys/common/dict/system"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="
                  this.$l('form_label_Primary_classification') || '一级分类'
                "
              >
                <dict-select
                  :placeholder="
                    this.$l('form_label_tip_category') || '请选择一个分类'
                  "
                  size="small"
                  clearable
                  filterable
                  v-model="form.masterCategoryCode"
                  :body="queryMasterCategoryParams"
                  url="/master/masterCategory/select"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="
                  this.$l('form_label_Secondary_classification') || '二级分类'
                "
              >
                <dict-select
                  :placeholder="
                    this.$l('form_label_tip_category') || '请选择一个分类'
                  "
                  size="small"
                  clearable
                  filterable
                  v-model="form.categoryCode"
                  :body="queryCategoryParams"
                  url="/master/masterCategory/select"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-col :span="8">
              <el-form-item
                :label="this.$l('from_label_Business_unit') || '部门名称'"
              >
                <dict-select
                  clearable
                  v-model="form.depCode"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  filterable
                  size="small"
                  url="/master/common/dict/depSelect"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="this.$l('from_label_Business_personnel') || '业务人员'"
              >
                <dict-select
                  clearable
                  v-model="form.fabricAgentCode"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  filterable
                  size="small"
                  url="/master/common/dict/baseUserSelect"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="this.$l('form_label_designer') || '设计师'">
                <dict-select
                  clearable
                  v-model="form.designerCode"
                  filterable
                  size="small"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('INDEX.form_label_please_select_designer') ||
                      '请选择设计师'
                  "
                  :selectedLabel.sync="form.designerName"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-col :span="8">
              <el-form-item
                :label="this.$l('form_label_create_date') || '创建时间'"
              >
                <el-date-picker
                  v-model="form.beginDate"
                  type="date"
                  size="small"
                  :picker-options="dateStartPicker"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item :label="this.$l('form_label_to') || '至'">
                <el-date-picker
                  v-model="form.endDate"
                  type="date"
                  size="small"
                  :picker-options="dateEndPicker"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 初始表单
const initForm = {
  keyword: '',
  productLine: '',
  masterCategoryCode: '',
  categoryCode: '',
}
export default {
  data() {
    return {
      form: { ...initForm },
      advqueryDialogVisible: false,
      productLineParams: { dictType: 'productLine' },
      queryCategoryParams: { parentCode: 'x', isEcom: 'N' },
      masterCategoryParams: { parentCode: '', isEcom: 'N' },
      queryMasterCategoryParams: { parentCode: 'x', isEcom: 'N' },
      dateStartPicker: this.dateEnd(),
      dateEndPicker: this.dateStart(),
    }
  },
  watch: {
    // 查询条件下拉
    'form.productLine'() {
      this.form.masterCategoryCode = ''
      this.form.categoryCode = ''
      this.queryCategoryParams = { parentCode: '', isEcom: 'N' }
      this.queryMasterCategoryParams = {
        parentCode: this.form.productLine,
        isEcom: 'N',
      }
    },
    'form.masterCategoryCode'() {
      this.form.categoryCode = ''
      this.queryCategoryParams = {
        parentCode: this.form.masterCategoryCode,
        isEcom: 'N',
      }
    },
  },

  activated() {
    this.query()
  },

  methods: {
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 初始查询
    query() {
      this.$emit('query', this.form)
    },
    dateEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endDate) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endDate).getTime() < time.getTime()
          }
        },
      }
    },
    dateStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginDate).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    exportData() {
      this.$emit('exportData', this.form)
    },
  },
}
</script>
